import React, {Component, createRef} from 'react';

// CSS
import './Exams.scss';

// Helper
import {setCookie, checkCookie} from '../../Helper/Cookies';
import { apiFetch, getCurrentUser } from '../../Helper/Api';

// Components
import Header from '../../components/Header/Header';
import { EmptyState, TableWait, StatTile, UserCell } from '../../components/UI/Feedback';
import { Toolbar, SelectEmpty } from '../../components/UI/Controls';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';

// Properties
const properties = require('../../properties.json');

class ExamsReports extends Component {
    constructor(props) {
        super(props);
        this.toast = createRef(null);
    }

    state = {
        globalFilter: null,

        // Teacher Identifier
        branchID: getCurrentUser()?.branchId,
        companyID: properties.company_id,
        selectedExam : null ,
        examStudentNumber : 0 ,
        // Data
        data: [],
        allExams : [],


        // which menus and tables are still waiting
        loadingExams: true,
        reportLoading: false,
    }

    getExams = () => {
        var _this = this;
        // Get Exams From API
        apiFetch("/exams")
        .then(fetchExams => {
            this.setState({
                allExams: fetchExams,
                loadingExams: false,
            });
        })
        .catch(error => {
            console.error('Error:', error)
            this.setState({ loadingExams: false });

            _this.toast.current.show({severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال'});
        });
    }


     getData = (examId) => {
        // Single report endpoint replaces the old examStudentNumber /
        // examStudentbestNumbers / mostMistakes trio. It only returns
        // attemptCount + a best-students list of {attemptId, studentProfileId,
        // score} -- there's no studentName/schoolStagesName/lessonName/degree/
        // solutionTime, and no "most mistakes" data at all in the new API.
        this.setState({ reportLoading: true });
        apiFetch(`/exams/${examId}/report`)
        .then(report => {
            this.setState({
                examStudentNumber: report.attemptCount,
                data: report.bestStudents,
                reportLoading: false,
            });
        })
        .catch(error => {
            console.error('Error:', error);
            this.setState({ reportLoading: false });
        });
     }

    componentDidMount () {
        document.title = properties.site_name + " | تقارير الإمتحانات";
        // Redirect To Sign In Page If The User Is Already Logged Out & Remove The Data If It Exists
        if (!checkCookie('name')) {
            window.localStorage.removeItem('currentTeacher');
            window.location.href = `/`;
        }

        this.getExams();
    }

    render() {
        const { selectedExam, data, reportLoading, examStudentNumber } = this.state;

        const allExams = this.state.allExams.map(exam => {
            return {
                label: exam.examName,
                value: exam.id
            }
        });

        // the scores the report did return, read as figures
        const scores = data.map(r => Number(r.score)).filter(n => isFinite(n));
        const best = scores.length ? Math.max(...scores) : null;
        const average = scores.length
            ? Math.round((scores.reduce((a, b) => a + b, 0) / scores.length) * 10) / 10
            : null;

        // the exam picker is what this whole page is about, so it sits on the
        // bar rather than behind anything
        const filters = (
            <span className="ui-filter is-inline">
                <Dropdown
                    value={selectedExam}
                    options={allExams}
                    onChange={(e) => this.setState({selectedExam: e.value} , this.getData(e.value))}
                    name="type"
                    placeholder="اختر الامتحان"
                    showClear
                    emptyMessage={<SelectEmpty loading={this.state.loadingExams} text="مفيش امتحانات" />}
                />
            </span>
        );

        // whoever the row is about, by name. The report carries the name and
        // mobile itself now, so the page no longer downloads every student in
        // the branch just to resolve a column of ids.
        const studentBody = (row) => {
            if (!row.studentName) {
                return <span className="ui-bits is-none">طالب #{row.studentProfileId}</span>;
            }
            return <UserCell name={row.studentName} sub={row.studentMobile} />;
        };

        const scoreBody = (row) => (
            <span className="ui-money">{row.score}</span>
        );

        return (
            <>
                <Header pageName="تقارير الإمتحانات" />

                <Toast ref={this.toast}></Toast>

                <div className="content">
                    <div className="container">
                        <div className="card">
                            <Card>
                                {/* The numbers the report carries, read before
                                    the rows. They only mean anything once an
                                    exam is chosen. */}
                                {selectedExam ? (
                                    <div className="ui-tiles">
                                        <StatTile
                                            icon="pi pi-users"
                                            tone="teal"
                                            label="عدد اللي أدوا الامتحان"
                                            value={reportLoading ? "…" : examStudentNumber}
                                        />
                                        <StatTile
                                            icon="pi pi-star"
                                            tone="gold"
                                            label="أعلى درجة"
                                            value={reportLoading ? "…" : (best === null ? "—" : best)}
                                        />
                                        <StatTile
                                            brand
                                            icon="pi pi-chart-line"
                                            label="متوسط الدرجات"
                                            value={reportLoading ? "…" : (average === null ? "—" : average)}
                                        />
                                    </div>
                                ) : null}

                                <Toolbar
                                    value={this.state.globalFilter || ''}
                                    onSearch={(v) => this.setState({ globalFilter: v })}
                                    placeholder="بحث في النتائج"
                                    count={!selectedExam || reportLoading ? null : `${data.length} نتيجة`}
                                    filters={filters}
                                />

                                <DataTable
                                    sortable
                                    globalFilter={this.state.globalFilter}
                                    className="p-datatable-responsive-demo p-datatable-gridlines p-datatable-striped"
                                    value={data}
                                    paginator
                                    rows={10}
                                    rowsPerPageOptions={[10,20,50]}
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                    emptyMessage={
                                        reportLoading ? (
                                            <TableWait />
                                        ) : !selectedExam ? (
                                            <EmptyState
                                                title="اختر امتحان الأول"
                                                hint="اختار امتحان من القائمة فوق علشان تشوف نتايج طلابك فيه"
                                                icon="pi pi-chart-bar"
                                            />
                                        ) : (
                                            <EmptyState
                                                title="مفيش نتايج للامتحان ده"
                                                hint="لسه محدش أدى الامتحان، أو مفيش محاولات مسجلة"
                                                icon="pi pi-inbox"
                                            />
                                        )
                                    }
                                >
                                    {/* sorted and searched by the name now that the
                                        report carries it, not by the profile id */}
                                    <Column sortable field="studentName" body={studentBody} header="الطالب"></Column>
                                    <Column sortable field="score" body={scoreBody} header="الدرجة"></Column>
                                </DataTable>
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default ExamsReports;
